import api from '../token';

export const DeleteProduto = async (dados) => {
  try {
    const response = await api.post('/deleteProduto', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

